import { render } from "./App.vue?vue&type=template&id=72c4edbc&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=72c4edbc&scoped=true&lang=css"
import "./App.vue?vue&type=style&index=1&id=72c4edbc&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72c4edbc"]])

export default __exports__